import * as React from "react";
import { Col } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useAuth0 } from "../auth/react-auth0-wrapper";

const Address = ({ address, errors, onChange, readOnly }) => {
  const { geo } = useAuth0();

  const onAddressChange = changedProps => {
    const newAddress = { ...address, ...changedProps };
    onChange({
      value: newAddress
    });
  };

  return (
    <React.Fragment>
      <Col sm="3" xs="6">
        <strong className="mt-2">Indirizzo</strong>
        <InputText
          disabled={readOnly ? true : false}
          className={errors.street ? "p-error" : ""}
          value={address.street || ""}
          style={{ width: "100%" }}
          onChange={e => onAddressChange({ street: e.target.value })}
        />
      </Col>
      <Col sm="3" xs="6">
        <strong className="mt-2">Regione</strong>
        <Dropdown
          filter
          filterBy="label"
          id="region"
          disabled={readOnly ? true : false}
          className={errors.region ? "p-error" : ""}
          value={address.region || ""}
          showClear={true}
          style={{ width: "100%" }}
          options={geo.getRegions()}
          onChange={e =>
            onAddressChange({
              region: e.value,
              province: "",
              cap: "",
              city: ""
            })
          }
        />
      </Col>
      <Col sm="2" xs="2">
        <strong className="mt-2">Provincia</strong>
        <Dropdown
          filter
          filterBy="label"
          id="province"
          disabled={readOnly ? true : false}
          className={errors.province ? "p-error" : ""}
          value={address.province || ""}
          showClear={true}
          style={{ width: "100%" }}
          options={address.region ? geo.getProvinces(address.region) : []}
          onChange={e =>
            onAddressChange({ province: e.value, cap: "", city: "" })
          }
        />
      </Col>
      <Col sm="3" xs="3">
        <strong className="mt-2">Cittá/Comune</strong>
        <Dropdown
          filter
          filterBy="label"
          id="city"
          disabled={readOnly ? true : false}
          className={errors.city ? "p-error" : ""}
          value={address.city || ""}
          showClear={true}
          style={{ width: "100%" }}
          options={address.province ? geo.getComuni(address.province) : []}
          onChange={e => onAddressChange({ city: e.value, cap: "" })}
        />
      </Col>
      <Col sm="1" xs="1">
        <strong className="mt-2">Cap</strong>
        <Dropdown
          filter
          filterBy="label"
          id="cap"
          disabled={readOnly ? true : false}
          className={errors.cap ? "p-error" : ""}
          value={address.cap || ""}
          showClear={true}
          style={{ width: "100%" }}
          options={address.city ? geo.getCap(address.city) : []}
          onChange={e => onAddressChange({ cap: e.value })}
        />
      </Col>
    </React.Fragment>
  );
};

export default Address;
